/* @flow */
import idx from 'idx';
import * as React from 'react';
import { graphql } from 'react-apollo';
import GET_ADMIN_ORG_INTEGRATION_PERMISSIONS from 'admin/queries/AdminOrgIntegrationPermissions.gql';

type Props = {
  data: *,
  children: Function,
  organizationUUID: string,
};

class OrganizationIntegrationPermissions extends React.Component<Props, {}> {
  render() {
    return this.props.children({
      loading: this.props.data.loading,
      canSee: idx(
        this.props,
        _ => _.data.organizations[0].permissions.adminConsole.seeConnectedAccountsTab
      ),
      canEdit: idx(
        this.props,
        _ => _.data.organizations[0].permissions.canEditOrganizationIntegrationSettings
      ),
      parentId: idx(
        this.props,
        _ => _.data.organizations[0].parentId
      ),
    });
  }
}

const withPermission = graphql(
  GET_ADMIN_ORG_INTEGRATION_PERMISSIONS,
  {
    options: ({ organizationUUID }) => ({
      variables: { organizationUUID },
    }),
  }
);

export default withPermission(OrganizationIntegrationPermissions);
